import React from 'react';
const links = ['Termini di Servizio', 'Privacy Policy', 'Refund Policy', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-79" data-mp="3ggtxuh7dth4p">
      <div className="mx-auto max-w-5xl text-center" data-id="element-80" data-mp="32oe3e4sjqrfe">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-81" data-mp="32pp601a99t4x">
          DANCE PRONTA™
        </p>
        <nav aria-label="Footer" data-id="element-82" data-mp="3uf0opddwyguv">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-83" data-mp="3ues7xaeo6ree">
            {links.map(link => <li key={link} data-id="element-84" data-mp="3lecbgkwcgkj1">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-85" data-mp="3lf56iolxxllc">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-86" data-mp="2a1jkhcbdo041">
          © 2026 DANCE PRONTA™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}